import React from 'react';
import { Heading, Paragraph } from 'grommet';

export const PrivacyNotice = (props) => (
  <>
    <Heading level={2}>Playable Data Policy 2021</Heading>
    <Paragraph>
      This Privacy Notice has been drawn up for Free Ice Cream’s Playable Data mapping work.
    </Paragraph>
    <Heading level={3}>Who is collecting the data?</Heading>
    <Paragraph>
      Free Ice Cream partners with the client as Joint Data Controllers.  These organisations facilitate the community to collect data about itself which is then held securely by Free Ice Cream and any third party data processing software necessary to deliver the service.
    </Paragraph>

    <Heading level={3}>What data is being collected?</Heading>
    <Paragraph>
      <Paragraph>
        Data is being collected about who is in a community: organisational names and characteristics, individual names, the goals people are working towards, and who is connected to who.
      </Paragraph>
      <Heading level={4}>We collect three categories of personal data:</Heading>
      <Paragraph>
        <b>The email addresses of everyone who contributes to the mapping process.</b>  These are collected in order to authorise users to access their community map and to restrict access to anyone not in the community. These emails are collected and then held separately on authorisation software servers.
      </Paragraph>
      <Paragraph>
        <b>The names of everyone who contributes to the mapping process.</b> By agreeing to this data policy you give your permission for us to publish your name on the map we are making.  Your name will only be visible to people authorised by the community anchor organisation and not to the general public.
      </Paragraph>
      <Paragraph>
        <b>The names of people who are named in the mapping process.</b> This data is only visible to those people authorised by the client and not to the general public.  If the named individuals are not made aware of this project and this Privacy Policy then their name will be deleted at 30 days.  If they are made aware of the project and the policy then their name can be kept for up to 90 days.  If they give their consent, their name can remain in the map.
      </Paragraph>
    </Paragraph>

    <Heading level={3}>
      What is the legal basis for processing the data?
    </Heading>
    <Paragraph>
      Section 6.1(a) of the GDPR allows for processing this data under <em>Consent</em> as a lawful basis.
    </Paragraph>

    <Heading level={3}>Will the data be shared anywhere?</Heading>
    <Paragraph>
      The map that is created will be shared with the contributors.  After 30 days some personal data may be erased in accordance with the guidance above.  
    </Paragraph>

    <Heading level={3}>How will the information be used?</Heading>
    <Paragraph>
      The client and the community will be able to use the map to explore the ways in which they are connected.  
    </Paragraph>

    <Heading level={3}>How long will the data be stored for?</Heading>
    <Paragraph>
      Free Ice Cream will store the data securely on their own and on
      authorisation software servers until the community wants it deleted.
    </Paragraph>

    <Heading level={3}>What rights do I have?</Heading>
    <Paragraph>
      You have rights over any and all information stored on the system related
      to yourself (unless it would infringe on another person’s privacy to
      access it) and therefore you may:
      <ul>
        <li>view it (or ask for a copy),</li>
        <li>ask for it to be amended (if incorrect or irrelevant),</li>
        <li>request for it to be deleted.</li>
      </ul>
      To exercise the above rights, please contact us at
      admin@freeicecream.co.uk
    </Paragraph>

    <Heading level={3}>
      The community has a part to play, and a responsibility:
    </Heading>
    <Paragraph>
      <ol>
        <li>
          As part of the mapping, you will name people and organisations that are not in the room with you.  We ask that you tell anyone you named in the map about this mapping process and send them this Privacy Policy, which we will provide to you.  If they are part of an organisation, please invite them to get in touch with the project leaders to join the mapping process and make the map as representative of the community as possible.
        </li>
        <li>
          The information you receive or have access to through use of our services should only be used for its specified purposes, for no longer than needed and you must not keep, make a copy or share it.
        </li>
      </ol>
    </Paragraph>
    <Paragraph>
      <Heading level={3}>As we develop these mapping tools and their use in communities, our data policy is likely to change and will be updated accordingly.  From time to time you will need to read and agree these changes to keep using the service.  You can always email us at admin@freeicecream.co.uk if you would like your data to be amended or deleted. (Version 1 / 24 May 2021)</Heading>
    </Paragraph>
  </>
);
